// extracted by mini-css-extract-plugin
export default {"root":"_1Y7TX","icon":"_39fkb"};